<template lang="pug">
  div(v-bind="(getBlockAttributes(block))")
    Block(
      v-show="block.innerBlocks[0].innerBlocks.length"
      v-for="(innerBlock, key) in block.innerBlocks[0].innerBlocks"
      v-bind="{ id: 'icon-table' + '-' + key, class: 'icon-table' }"
      :key="`iconTable${key}`"
      :block="innerBlock")

</template>

<script>
import { getBlockAttributes } from "~/utils/block"

export default {
  name: "AvIconTable",

  props: {
    block: {
      type: Object, // Record<string, any>
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {}
  },

  computed: {},

  methods: {
    getBlockAttributes(block) {
      return getBlockAttributes(block)
    }
  }
}
</script>

<style lang="css" module>
:global {
  .av-icon-table {
    @apply flex justify-center gap-x-[8%];

    .av-column {
      @apply flex flex-col gap-y-ds-sm;

      .av-media_text {
        & > div {
          @apply flex flex-col items-center text-center gap-x-ds-sm gap-y-ds-xxs mb-ds-md;
          min-height: 102px;

          .mediaTextInnerContainer {
            @apply flex flex-col grow-[1];

            .av-paragraph:last-child {
              @apply text-base mb-0;
            }

            .av-paragraph:first-child {
              @apply text-rebrandSm font-bold my-auto;
            }
          }
          .imageWrap {
            img {
              min-width: 40px;
            }
          }
        }
      }
    }
  }
}

@screen sm {
  :global {
    .av-icon-table {
      @apply gap-x-[12%];
    }
  }
}

@screen md {
  :global {
    .av-icon-table {
      .av-column {
        .av-media_text {
          @apply self-start;

          & > div {
            @apply flex-row items-start text-left gap-x-ds-md mb-ds-ml;
            min-height: 58px;

            .mediaTextInnerContainer {
              @apply self-center;
            }
            .imageWrap {
              @apply self-center;

              img {
                min-width: 52px;
              }
            }
          }
        }
      }

      .av-column:last-child {
        @apply flex;
      }
    }
  }
}

@screen xl {
  :global {
    .av-icon-table {
      @apply gap-x-ds-ml;

      .av-column {
        .av-media_text {
          & > div {
            @apply gap-x-ds-ml mb-ds-lg;
            min-height: 71px;

            .imageWrap {
              img {
                min-width: 64px;
              }
            }

            .mediaTextInnerContainer {
              .av-paragraph:last-child {
                @apply text-rebrandSm;
              }

              .av-paragraph:first-child {
                @apply text-rebrandMd;
              }
            }
          }
        }
      }
    }
  }
}
</style>
